import React from "react";
import { Navbar } from "../components/site/Navbar";
import { Footer } from "../components/site/Footer";
import { Marquee } from "../components/site/Marquee";
import { Hero } from "../sections/Hero";
import { About } from "../sections/About";
import { IntroVideo } from "../sections/IntroVideo";
import { Services } from "../sections/Services";
import { Execution } from "../sections/Execution";
import { AIDigital } from "../sections/AIDigital";
import { People } from "../sections/People";
import { Industries } from "../sections/Industries";
import { Approach } from "../sections/Approach";
import { WhyUs } from "../sections/WhyUs";
import { Founder } from "../sections/Founder";
import { Qualifications } from "../sections/Qualifications";
import { ClientLogos } from "../sections/ClientLogos";
import { Consultancy } from "../sections/Consultancy";
import { Technology } from "../sections/Technology";
import { Insights } from "../sections/Insights";
import { Testimonials } from "../sections/Testimonials";
import { CTA } from "../sections/CTA";
import { Contact } from "../sections/Contact";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <IntroVideo />
        <Services />
        <Execution />
        <AIDigital />
        <People />
        <Industries />
        <Approach />
        <WhyUs />
        <Founder />
        <Qualifications />
        <ClientLogos />
        <Consultancy />
        <Technology />
        <Insights />
        <Testimonials />
        <CTA />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
